<template>
    <div class="mt-2 font-weight-semibold color-brand--secondary" v-html="labelText"></div>
</template>

<script>
    export default {
        props: {
            pageFilterType: {
                type: String,
                required: true,
            },
            inputName: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                eventName: this.pageFilterType + '-' + this.inputName,
                labelText: '',
            };
        },
        mounted() {
            // Listen for updated label text
            VueEvents.$on(this.eventName + ':update', labelText => {
                this.labelText = labelText;
            });
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/movies/FilterLabel.vue